import { ArrowUturnRightIcon } from "@heroicons/react/20/solid";
import { Button, ButtonState } from "src/components/Button";
import { useTranslation } from "src/translations";

export function HistoryRedoButton({
  onClick,
  disabled,
}: {
  onClick: () => void;
  disabled: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Button
      title={t("toolbox.redo")}
      Icon={ArrowUturnRightIcon}
      state={!disabled ? ButtonState.NONE : ButtonState.DISABLED}
      onClick={onClick}
    />
  );
}
